export default "__VITE_ASSET__f2855458__"